import forge from '../assets/finance/loading-forge.webp';

/** Animation d'attente sans progression fictive. Le parent la démonte à la
 * réception des données, en cas d'erreur ou à l'entrée du mode démo. */
export function FinanceLoadingForge(): React.JSX.Element {
  return (
    <div className="finance-loading" role="status" aria-label="Chargement des finances en cours">
      <div className="finance-loading__forge" aria-hidden="true">
        <img src={forge} alt="" width="448" height="448" />
        <i className="finance-loading__glow" />
        <span className="finance-loading__embers">
          <i />
          <i />
          <i />
          <i />
          <i />
        </span>
      </div>
    </div>
  );
}
